module.exports = __webpack_public_path__ + "img/post-search-active.cb4eda00.svg";